import { HlmTextarea } from './lib/hlm-textarea';

export * from './lib/hlm-textarea';

export const HlmTextareaImports = [HlmTextarea] as const;
